"use client"

import { useState } from "react"
import { Button } from "./ui/button"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog"
import { Lock } from "lucide-react"
import { Input } from "./ui/input"

export function ChangePasswordModal({ isOpen, onClose, userId, onChangePassword }) {
    const [formData, setFormData] = useState({
      newPassword: "",
      confirmPassword: "",
    })
  
    const [errors, setErrors] = useState({})
  
    const handleChange = (e) => {
      const { name, value } = e.target
      setFormData((prev) => ({ ...prev, [name]: value }))
  
      // Clear error when field is edited
      if (errors[name]) {
        setErrors((prev) => ({ ...prev, [name]: null }))
      }
    }
  
    const validateForm = () => {
      const newErrors = {}
  
      if (!formData.newPassword) {
        newErrors.newPassword = "New password is required"
      } else if (formData.newPassword.length < 6) {
        newErrors.newPassword = "Password must be at least 6 characters"
      }
  
      if (formData.newPassword !== formData.confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match"
      }
  
      setErrors(newErrors)
      return Object.keys(newErrors).length === 0
    }
  
    const handleSubmit = (e) => {
      e.preventDefault()
  
      if (validateForm()) {
        // Pass the correct payload structure that the service expects
        const passwordData = {
          password: formData.newPassword,
          confirmPassword: formData.confirmPassword
        }
        
        onChangePassword(userId, passwordData)
  
        // Reset form
        setFormData({
          newPassword: "",
          confirmPassword: "",
        })
  
        onClose()
      }
    }
  
    return (
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent className="sm:max-w-md p-0 overflow-hidden">
          <DialogHeader className="px-6 pt-6 pb-2">
            <DialogTitle className="text-xl font-medium">Change Password</DialogTitle>
          </DialogHeader>
          <form onSubmit={handleSubmit} className="px-6 pb-6 space-y-4">
            <div className="space-y-4">
              <div className="relative">
                <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-gray-500" />
                </div>
                <Input
                  id="newPassword"
                  name="newPassword"
                  type="password"
                  placeholder="Password"
                  value={formData.newPassword}
                  onChange={handleChange}
                  className={`pl-10 py-5 ${errors.newPassword ? "border-red-500" : ""}`}
                />
                {errors.newPassword && <p className="text-xs text-red-500 mt-1">{errors.newPassword}</p>}
              </div>
  
              <div className="relative">
                <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-gray-500" />
                </div>
                <Input
                  id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  placeholder="Confirm Password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className={`pl-10 py-5 ${errors.confirmPassword ? "border-red-500" : ""}`}
                />
                {errors.confirmPassword && <p className="text-xs text-red-500 mt-1">{errors.confirmPassword}</p>}
              </div>
            </div>
  
            <Button type="submit" className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-medium py-5">
              Save
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    )
}